import { render } from "./MycenterM.vue?vue&type=template&id=96c8abda&scoped=true"
import script from "./MycenterM.vue?vue&type=script&lang=js"
export * from "./MycenterM.vue?vue&type=script&lang=js"

import "./MycenterM.vue?vue&type=style&index=0&id=96c8abda&lang=scss"
import "./MycenterM.vue?vue&type=style&index=1&id=96c8abda&lang=scss&scoped=true"

import exportComponent from "G:\\官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c8abda"]])

export default __exports__